module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_plan.dee5d946.svg";